module.exports = __webpack_public_path__ + "img/jxl1.4d830944.png";